export enum CookiesItemEnum {
  BEARER_TOKEN = "BEARER_TOKEN",
  BEARER_TOKEN_EXPIRE = "BEARER_TOKEN_EXPIRE",
  BEARER_TOKEN_DEXTER = "BEARER_TOKEN_DEXTER",
  BEARER_TOKEN_EXPIRE_DEXTER = "BEARER_TOKEN_EXPIRE_DEXTER",
  BEARER_TOKEN_PAYMENT = "BEARER_TOKEN_PAYMENT",
  BEARER_TOKEN_EXPIRE_PAYMENT = "BEARER_TOKEN_EXPIRE_PAYMENT",
  SESSION_TOKEN = "SESSION_TOKEN",
  COOKIE_I18N_NEXT_LANG_NAME = "i18nextLng",
  COOKIE_UTM_ID = "utmid",
  COOKIE_ACCOUNT_ID = "accountId",
  COOKIE_ACCOUNT_IMAGE = "accountImage",
  COOKIE_FLIGHT_SEARCH_RESULT = "flightSearchResult",
  COOKIE_ACCOUNT_NAME = "accountName",
  FEATURES_SCOPED = "featureScoped",
  COOKIE_ACCOUNT_ID_MOBILE = "accountIdMobile",
  DISPLAY_NAME_MOBILE = "displayNameMobile",
  IS_LOGIN_MOBILE = "IS_LOGIN_MOBILE",

  // มี hardcode ไว้ที่ script head ถ้าเปลี่ยนตัวแปร ให้แก้ไฟล์ Head ด้วย
  COOKIE_PARTNER_TOKEN_ID = "partnerTokenId",
  COOKIE_CLEAR_ALL_STORAGE = "COOKIE_CLEAR_ALL_STORAGE",

  // cookies consent
  NECESSARY_COOKIES = "NecessaryCookies",
  ADVERTISING_COOKIES = "AdvertisingCookies",

  IS_DISABLE_TEMPLATE = "isDisableTemplate",
  IS_PAYMENT_TIMEOUT = "payment_timeout",
  // cookie
  GA4_DISPLAY_MODE_COOKIES = "GA4_DISPLAY_MODE_COOKIES",

  CURRENT_PATH = "currentPath",
  CURRENT_QUERYSTRING = "currentQuerystring",
  USER_IP_ADDRESS = "userIpAddress",
  USER_COUNTRY = "USER_COUNTRY",

  PREFERRED_CURRENCY = "PREFERRED_CURRENCY",
  DISTANCE_UNIT = "DISTANCE_UNIT",
  PRICE_DISPLAY = "PRICE_DISPLAY",
  GA_CLIENT_ID = "_ga",

  // facebook pixel
  FBP = "_fbp",
  FBC = "_fbc",

  // spin survey answer
  SURVEY_ANSWER = "SURVEY_ANSWER",

  IS_DESKTOP = "IS_DESKTOP",
  IS_REGIS_BYPASS_UTM = "IS_REGIS_UTM",

  UTM_CLIENT = "UTM_CLIENT",
  IS_REGIS_CLIENT = "IS_REGIS_CLIENT",
  TIME_REGIS_BYPASS_EXPIRE_UTM = "TIME_REGIS_BYPASS_EXPIRE_UTM",

  // redirect
  COOKIE_UTM_CHANNEL = "channel",
  COOKIE_UTM_SOURCE = "utm_source",
  COOKIE_UTM_MEDIUM = "utm_medium",
  COOKIE_UTM_CAMPAIGN = "utm_campaign",
  COOKIE_UTM_CONTENT = "utm_content",

  COOKIE_TIKTOK_ID = "ttclid",
  COOKIE_TIKTOK_TTP = "_ttp",
}
